<script setup>
import { useStore } from 'vuex';
import {
  computed,
  ref,
  watch,
} from 'vue';

const store = useStore();
const notification = computed(() => store.state.notification);
const notifications = ref([]);
let nextId = 0;

const dismiss = (id) => {
  notifications.value = notifications.value.filter((_notification) => _notification.id !== id);
};

watch(notification, (newVal) => {
  const id = nextId++;
  notifications.value.push({ ...newVal, id });

  setTimeout(() => dismiss(id), 5000);
});
</script>

<template>
  <div class="notification-container position-fixed">
    <transition-group
      name="notifications"
      tag="div"
      class="notification-list"
    >
      <div
        v-for="_notification in notifications"
        :key="_notification.id"
        class="card-notification text-center"
        :class="`notification-${_notification.type || 'info'}`"
        @click="dismiss(_notification.id)"
      >
        <h6 class="m-0 notification-title">{{ $t(_notification.title) }}</h6>
        <div
          class="notification-message"
          v-if="_notification.message"
        >
          {{ $t(_notification.message) }}
        </div>
      </div>
    </transition-group>
  </div>
</template>

<style scoped>
.notification-container {
  z-index: 11050;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
}

.notification-list {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
}

.card-notification {
  min-width: 420px;
  max-width: 480px;
  padding: 0.9rem 1.25rem;
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(6px);
  border-radius: 0.5rem;
  border-left: 4px solid var(--bs-info, #0dcaf0);
  box-shadow: 0 0.5rem 1.5rem rgba(0, 0, 0, 0.15);
  cursor: pointer;
}

.card-notification:first-child {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.notification-title {
  font-weight: 600;
  color: #212529;
}

.notification-message {
  margin-top: 0.15rem;
  color: #495057;
  font-size: 0.875rem;
}

.notification-success {
  border-left-color: var(--bs-success, #198754);
}

.notification-success .notification-title {
  color: var(--bs-success-text-emphasis, #0a3622);
}

.notification-danger {
  border-left-color: var(--bs-danger, #dc3545);
}

.notification-danger .notification-title {
  color: var(--bs-danger-text-emphasis, #58151c);
}

.notification-warning {
  border-left-color: var(--bs-warning, #ffc107);
}

.notification-warning .notification-title {
  color: var(--bs-warning-text-emphasis, #664d03);
}

.notifications-enter-active,
.notifications-leave-active {
  transition: all 0.5s ease;
}

.notifications-enter-from,
.notifications-leave-to {
  opacity: 0;
  transform: translateY(-20px);
}

@media (max-width: 576px) {
  .notification-container {
    left: 0;
    transform: none;
    width: 100%;
    padding: 0 0.5rem;
  }

  .notification-list {
    align-items: stretch;
  }

  .card-notification {
    min-width: 0;
    max-width: none;
    width: 100%;
  }
}
</style>
